import { get } from '../request';

export async function fetchDashboardData(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisaldemo/dashboard`;
  const { body } = await get(authenticationToken, url);
  return body;
}
